import { Form } from 'antd'
import { DefaultOptionType } from 'antd/es/select'

import { useEffect, useState } from 'react'

import {
  useGetCompaniesQuery,
  useLazyGetBranchesQuery,
} from 'modules/Orders/services/ordersApi'

export const useUserSelectOptions = () => {
  const { data: companies, isLoading: isLoadingCompanies } =
    useGetCompaniesQuery({ params: { is_crm: 'true' } })
  const [getBranches, { data: branches, isLoading: isLoadingBranches }] =
    useLazyGetBranchesQuery()

  const currentBrand = Form.useWatch('company')
  const [companyOptions, setCompanyOptions] = useState<DefaultOptionType[]>([])
  const [branchOptions, setBranchOptions] = useState<DefaultOptionType[]>([])

  useEffect(() => {
    if (companies?.success) {
      setCompanyOptions(
        companies.result.map((company) => ({
          label: company.name,
          value: company.slug,
        })),
      )
    }
  }, [companies])

  useEffect(() => {
    if (branches?.success) {
      setBranchOptions(
        branches.result.map((branch) => ({
          label: branch.title,
          value: branch.slug,
        })),
      )
    }
  }, [branches])

  useEffect(() => {
    setBranchOptions([])
    if (currentBrand) {
      getBranches({
        params: {
          company__slug: currentBrand,
        },
      })
    }
  }, [currentBrand])

  return {
    companyOptions,
    isLoadingCompanies,
    branchOptions,
    isLoadingBranches,
  }
}
